module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-brands-400.svg?9769d0a6a42cf73df12bc63a7a994131";